import type { ProviderAccountMetadata } from '@viko/protocol'

export function accountUsable(account: ProviderAccountMetadata): boolean {
  return account.enabled && (account.mode === 'legacy' || account.readiness === 'ready')
}
export function accountStatus(account: ProviderAccountMetadata): string {
  if (!account.enabled) return 'Disabled'
  if (account.mode === 'legacy') return 'Existing CLI login · not checked'
  return {
    unknown: 'Not checked',
    ready: 'Ready',
    'login-required': 'Sign in required',
    unavailable: 'CLI unavailable',
  }[account.readiness]
}
